import React from "react";
import { Col, Row } from "react-bootstrap";
import fundRaisingImg1 from "../../assets/startups/fundingStartup/IHub-Data_Wadhwani_image.webp";
import advani from "../../assets/startups/fundingStartup/image-2.webp";
import hdfc from "../../assets/startups/fundingStartup/hdfc-grant.webp";

export default function fundRaising() {
  return (
    <>
      <Col xs={12} sm={12} md={12} className="p-4 p-sm-2 p-md-4">
      <div className="fundRaise-box">
          <Row className="m-0 cus_hub_team_row">
            <Col xs={12} sm={12} md={5} lg={5} className="p-2">
              <img
                src={hdfc}
                alt=""
                className="img-fluid rounded-4"
              />
            </Col>
            <Col xs={12} sm={12} md={7} lg={7} className="p-2 pt-0 pt-md-4">
              {/* <h4 className="hubTeam-main-head fw-bold">Hello</h4> */}
              <p className="hubTeam-sub-head">
            
                  The HDFC Bank Parivartan Grant Challenge invites startups, innovators, and disruptors to take center stage and redefine the future through tech-driven research startups. This is your chance to secure grants of up to ₹15 Lakhs!
                  </p>
                  <p className="my-1">
                  <b>REGISTER HERE: </b><a href="https://parivartan.accubate.app/ext/form/3111/1/apply" target="__blank">https://parivartan.accubate.app/ext/form/3111/1/apply</a>
                  </p>
                  <p className="fw-bold mb-0">Important dates:</p>
                  <ul className="md:inline-block">
                    <li>
                    <b>Application Opens:</b> 15th January 2025
                    </li>
                    <li><b>Deadline for Submission:</b> 7st February 2025</li>
                  </ul>
              <p>
              <b>About HDFC Bank’s Parivartan Grants</b><br />
              HDFC Bank’s Parivartan Grants program contributes towards social development in India by supporting emerging innovative startups working in the social space via incubators supporting solutions across the Environment, Agri Business, Education, Waste Management, Healthcare, Skill Development and Gender Diversity & Inclusion.
              </p>
            </Col>
          </Row>
        </div>

        <div className="fundRaise-box">
          <Row className="m-0 cus_hub_team_row">
            <Col xs={12} sm={12} md={5} lg={5} className="p-2">
              <img
                src={fundRaisingImg1}
                alt=""
                className="img-fluid rounded-4"
              />
            </Col>
            <Col xs={12} sm={12} md={7} lg={7} className="p-2 pt-0 pt-md-4">
              {/* <h4 className="hubTeam-main-head fw-bold">Hello</h4> */}
              <p className="hubTeam-sub-head">
                Calling Healthcare and Mobility DeepTech AI/ML startups to raise
                funding and accelerate growth with Wadhwani Liftoff in
                collaboration with{" "}
                <a
                  href="https://www.linkedin.com/company/wadhwanifoundation/"
                  target="__blank"
                >
                  Wadhwani Foundation!
                </a>
              </p>
              <p className="hubTeam-sub-head">
                This 4-12 week programme will help in funding and growth of
                Early, Prototype or MVP Stage Startups in these domains.
              </p>
              <p className="hubTeam-sub-head">
                Apply Now! Click here to know more:{" "}
                <a
                  href="https://wadhwanifoundation.org/liftoff-batch/iiit-hyderabad/"
                  target="__blank"
                >
                  Learn More
                </a>
              </p>
            </Col>
          </Row>
        </div>

        <div className="fundRaise-box">
          <Row className="m-0 cus_hub_team_row">
            <Col xs={12} sm={12} md={5} lg={5} className="p-2">
              <img src={advani} alt="" className="img-fluid rounded-4" />
            </Col>
            <Col xs={12} sm={12} md={7} lg={7} className="p-2 pt-0 pt-md-4">
              {/* <h4 className="hubTeam-main-head fw-bold">Hello</h4> */}
              <p className="hubTeam-sub-head">
                Calling all DeepTech, MedTech, MediaTech, and Mobility startups!
                Ready to take your MVP to the next level?
              </p>
              <p className="hubTeam-sub-head">
                The Avishkar Winter Cohort 2024 is here to accelerate your
                growth! 💡 Get seed funding from IHub-Data, research support
                from IIITH, strategic guidance, investor connections, and more!
              </p>
              <p className="hubTeam-sub-head">What’s in it for you?</p>
              <ul className="list-unstyled">
                <li>✅ Seed funding up to INR 40L</li>
                <li>✅ Business & GTM mentorship</li>
                <li>✅ Access to IIITH's network of experts and investors</li>
                <li>✅ Investor pitch readiness</li>
                <li>
                  📅 Apply by October 21, 2024:{" "}
                  <a href="https://cie.iiit.ac.in/avishkar/" target="__blank">
                    Learn More
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </Col>
    </>
  );
}
